module.exports = __webpack_public_path__ + "static/media/1009189.1d510b38.png";